// extracted by mini-css-extract-plugin
export default {"consentBox":"ConsentBox_consentBox__JLq-Q"};